import { CLEAN_MEAL_PLANS_REQUESTS, LOAD_MEAL_PLANS_REQUESTS, LOAD_MEAL_PLANS_REQUESTS_ERROR, LOAD_MEAL_PLANS_REQUESTS_SUCCESS, LOAD_MEAL_PLANS_SELECT_ITEMS, LOAD_MEAL_PLANS_SELECT_ITEMS_ERROR, LOAD_MEAL_PLANS_SELECT_ITEMS_SUCCESS, SEARCH_MEAL_PLANS_REQUESTS, SEARCH_MEAL_PLANS_REQUESTS_ERROR, SEARCH_MEAL_PLANS_REQUESTS_SUCCESS } from "../types";

// Reducers
const initialState = {
    loading: false,
    selectItems: {
        mealPlans: [],
        campuses: []
    },
    search: {
        studentID: "",
        studentFirstName: "",
        studentLastName: "",
        campusID: null,
        mealPlanID: null,
        status: "Submitted",
    },
    mealPlansRequests: []

};

const mealPlanRequestsReducer = (state = initialState, { type, payload}) => {
    switch (type) {
        case LOAD_MEAL_PLANS_SELECT_ITEMS:
        case LOAD_MEAL_PLANS_SELECT_ITEMS_SUCCESS:
            return {
                ...state,
                selectItems: !payload ? initialState.selectItems : payload
            };
        case LOAD_MEAL_PLANS_SELECT_ITEMS_ERROR:
        case LOAD_MEAL_PLANS_REQUESTS:
        case LOAD_MEAL_PLANS_REQUESTS_SUCCESS:
            return {
                ...state,
                mealPlansRequests: !payload ? initialState.mealPlansRequests : payload
            }
        case LOAD_MEAL_PLANS_REQUESTS_ERROR:
        case SEARCH_MEAL_PLANS_REQUESTS:
            return {
                ...state,
                search: !payload ? initialState.search : payload
            }
        case SEARCH_MEAL_PLANS_REQUESTS_SUCCESS:
            return {
                ...state,
                mealPlansRequests: !payload ? initialState.mealPlansRequests : payload
            }
        case SEARCH_MEAL_PLANS_REQUESTS_ERROR:
        case CLEAN_MEAL_PLANS_REQUESTS:
            return {
                ...state,
                mealPlansRequests: initialState.mealPlansRequests
            }
        default:
            return state;
    }
};

export default mealPlanRequestsReducer;